import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought w-100">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="react-print-none">
                                                <p>Describe the situations below:</p>
                                                <div className="innovativeimg">
                                                    <div className="mobile-scroll md-lg-scroll">
                                                        <div align="center">
                                                            <div className="prioritise_excersise sept">
                                                                <div className="prioritextbox1">
                                                                <textarea className="prioritextbox"
                                                                          name="1"
                                                                          value={pageData?.DescribeTheSituations?.[1]}
                                                                          onChange={this.props.handleChangePageData('DescribeTheSituations')}/>
                                                                </div>

                                                                <div className="prioritextbox2">
                                                                   <textarea className="prioritextbox"
                                                                             name="2"
                                                                             value={pageData?.DescribeTheSituations?.[2]}
                                                                             onChange={this.props.handleChangePageData('DescribeTheSituations')}/>
                                                                </div>


                                                                <div className="prioritextbox3">
                                                                  <textarea className="prioritextbox"
                                                                            name="3"
                                                                            value={pageData?.DescribeTheSituations?.[3]}
                                                                            onChange={this.props.handleChangePageData('DescribeTheSituations')}/>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p style={{clear: 'both'}}>For each of these occasions, ask the
                                                    questions listed below to think about what went wrong.</p>
                                            </div>

                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print thought">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />

                                            <br/>
                                            <table className="ilead_v_sport people_active tablesrink"
                                                   border="0" cellpadding="0" cellspacing="0"
                                                   width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="center" width="100%">Did you try to
                                                        prioritise?
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen uiheading" align="left"
                                                        valign="top" width="100%">
                                                        <p>No? Then:</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="100%">
                                                        <ul className="greenbullet-list paraspace">
                                                            <li><p>Why not?</p></li>
                                                            <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.WhyNot?.textarea}
                                                                      onChange={this.props.handleChangePageData('WhyNot')}/>
                                                            <li className="cntareap"><p>What led you to not
                                                                prioritise your tasks on this
                                                                occasion?</p></li>
                                                            <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.WhatLedYouToNotPrioritiseYourTasksOnThisOccasion?.textarea}
                                                                      onChange={this.props.handleChangePageData('WhatLedYouToNotPrioritiseYourTasksOnThisOccasion')}/>

                                                        </ul>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen uiheading" align="left"
                                                        valign="top" width="100%">
                                                        <p>Yes? Then:</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="100%">
                                                        <ul className="greenbullet-list paraspace">
                                                            <li><p>How did you prioritise?</p></li>
                                                           <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.HowDidYouPrioritise?.textarea}
                                                                      onChange={this.props.handleChangePageData('HowDidYouPrioritise')}/>
                                                            <li><p>Did you prioritise the correct
                                                                task?</p></li>
                                                           <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.DidYouPrioritiseTheCorrectTask?.textarea}
                                                                      onChange={this.props.handleChangePageData('DidYouPrioritiseTheCorrectTask')}/>
                                                            <li><p> Did you have too many tasks to
                                                                do?</p></li>
                                                           <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.DidYouHaveTooManyTasksToDo?.textarea}
                                                                      onChange={this.props.handleChangePageData('DidYouHaveTooManyTasksToDo')}/>
                                                            <li><p>Could you have delegated tasks to
                                                                others?</p></li>
                                                           <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.CouldYouHaveDelegatedTasksToOthers?.textarea}
                                                                      onChange={this.props.handleChangePageData('CouldYouHaveDelegatedTasksToOthers')}/>
                                                            <li><p>Did the task take longer than
                                                                expected?</p></li>
                                                           <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.DidTheTaskTakeLongerThanExpected?.textarea}
                                                                      onChange={this.props.handleChangePageData('DidTheTaskTakeLongerThanExpected')}/>
                                                            <li><p>Did you stick to your priorities?</p>
                                                            </li>
                                                           <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.DidYouStickToYourPriorities?.textarea}
                                                                      onChange={this.props.handleChangePageData('DidYouStickToYourPriorities')}/>
                                                            <li className=" cntareap uiheading"><p> Finally
                                                                outline your prioritisation type
                                                                below.</p></li>
                                                           <textarea className="textareaheigh_prioritise"
                                                                      name="textarea"
                                                                      value={pageData?.FinallyOutlineYourPrioritisationTypeBelow?.textarea}
                                                                      onChange={this.props.handleChangePageData('FinallyOutlineYourPrioritisationTypeBelow')}/>

                                                        </ul>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div
                                                className="lightgreencontentbg keyquestionpadnew uiheading lightbgcenter">
                                                <table width="100%" border="0" cellspacing="0"
                                                       cellpadding="0">
                                                    <tbody>
                                                    <tr>
                                                        <td width="28%" align="left"><p><span
                                                            className="green brownbold lightbg_text"><span
                                                            className="">My prioritisation type is: </span></span>
                                                        </p></td>
                                                        <td width="72%" align="left">
                                                            <span className="lightbg_cell">
                                                                <span className="ilead-slect-box select">
                                                                    <select name="select"
                                                                            value={pageData?.MyPrioritisationTypeIs?.select}
                                                                            className="custom-dropdown"
                                                                            onChange={this.props.handleChangePageData('MyPrioritisationTypeIs')}>
                                                                         <option value="cant_say_no">Can' t say no</option>
                                                                        <option value="starter_not_completer">Starter not completer</option>
                                                                        <option value="the_optimistic">The optimistic</option>
                                                                        <option value="the_perfectionist">The perfectionist</option>
                                                                        <option value="not_enough_time_to_set_priorities_and_other">Not enough time to set priorities and other</option>
                                                                        <option value="others">Others</option>
                                                                    </select>
                                                                </span>
                                                            </span>

                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>


                                            </div>

                                            <div className="react-print-none">
                                                <div className="circle_title"><span className="heading"><img
                                                    src={require('@images/greendot.jpg')}
                                                    className="heading_image"/></span><span className="heading">
                       MATCH PRIORITY TYPE TO STRATEGY
                       </span></div>
                                                <p>So, you now know what your prioritisation type is. If you are a
                                                    ‘starter but not a finisher’ this final
                                                    part might be a bit stretching for you, but hang in there! The
                                                    final part of this tool is to think about
                                                    strategies you can employ to ensure you prioritise effectively.
                                                    This will be different for
                                                    every person.</p>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page7')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}